import {autorun, toJS} from "mobx";

export const autoSave = (sourceStore, storeName, blacklist = []) => {
    let firstRun = true;
    autorun(async () => {
        const jsStoreData = toJS(sourceStore);
        for (const item of blacklist) {
            delete jsStoreData[item];
        }
        const storeData = JSON.stringify(jsStoreData);
        if (!firstRun) {
            await localStorage.setItem(storeName, storeData);
        }
        firstRun = false;
    });
};
export const loadStore = (targetStore, storeName) => {
    const storeData = localStorage.getItem(storeName);
    const parsedStore = JSON.parse(storeData);
    if(!targetStore){
        return parsedStore;
    }
    if (storeData) {
        Object.keys(parsedStore).forEach(key => {
            targetStore[key] = parsedStore[key];
        });
    }
};

export const resetStore = storeName => {
    localStorage.removeItem(storeName);
};
